import { render, staticRenderFns } from "./TableContact.vue?vue&type=template&id=d9cdaddc&"
import script from "./TableContact.vue?vue&type=script&lang=ts&"
export * from "./TableContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports